import { API } from 'utils/api.config';

export async function getAllFeedsApi(page) {
  return await API.get(`api/feed?page=${page}`);
}
